import { Player } from '../types/game';
import { gameRules } from './gameRules';
import { validateScoreEntry } from './validation';
import { applyTurnStats, TurnStatsContext } from './stats';

export interface ScoreValidationResult {
  isValid: boolean;
  resultingScore: number;
  error?: string;
}

export function validateAndComputeScore(
  delta: number,
  prevScore: number,
  hasFirstEntry: boolean,
  canUseSingleDie: boolean,
  tunnels: boolean,
): ScoreValidationResult {
  const validation = validateScoreEntry(delta, prevScore, hasFirstEntry, canUseSingleDie, tunnels);
  const resultingScore = prevScore + delta;
  return {
    isValid: validation.isValid,
    resultingScore,
    error: validation.error,
  };
}

export interface ScoreApplicationResult {
  player: Player;
  isWinner: boolean;
  hasFirstEntry: boolean;
}

export function applyScoreToPlayer(
  player: Player,
  delta: number,
  resultingScore: number,
): ScoreApplicationResult {
  const hasFirstEntry = player.hasFirstEntry
    || resultingScore >= gameRules.scoring.firstEntryMin
    || delta >= gameRules.scoring.firstEntryMin;
  const isWinner = resultingScore >= gameRules.scoring.winScore;

  const statsContext: TurnStatsContext = {
    previousScore: player.score,
    newScore: resultingScore,
    baseDelta: resultingScore - player.score,
    isPass: resultingScore <= player.score,
  };

  const updatedPlayer = applyTurnStats(player, statsContext);

  return {
    player: {
      ...updatedPlayer,
      score: resultingScore,
      hasFirstEntry,
      isWinner,
    },
    isWinner,
    hasFirstEntry,
  };
}
